import React, { createContext, useContext } from 'react';
import { DEFAULT_COMPANY_WORDS } from '../lib/companyWords';

// The company's own words (today: what it calls a booking). CRMApp provides them; any screen rendered without the
// provider (tests, the screenshot harness) reads the defaults, so it says "Engagements" exactly as before.
const CompanyWordsContext = createContext(DEFAULT_COMPANY_WORDS);

export function CompanyWordsProvider({ words, children }) {
    return <CompanyWordsContext.Provider value={words || DEFAULT_COMPANY_WORDS}>{children}</CompanyWordsContext.Provider>;
}

export function useCompanyWords() {
    return useContext(CompanyWordsContext);
}
